export const common = {
  // Authentication
  "login": "تسجيل الدخول",
  "username": "اسم المستخدم",
  "password": "كلمة المرور",
  "loginButton": "دخول",
  "logout": "تسجيل الخروج",
  
  // Main Navigation
  "home": "الرئيسية",
  "newRequest": "طلب حاوية جديدة",
  "replaceContainer": "تبديل حاوية ممتلئة",
  "finalPickup": "رفع نهائي للحاوية",
  "myRequests": "طلباتي",
  "profile": "الملف الشخصي",
  
  // Request Status
  "new": "جديد",
  "inProgress": "قيد التنفيذ",
  "completed": "منجز",
  "pending": "في الانتظار",
  
  // Form Fields
  "location": "الموقع",
  "notes": "الملاحظات",
  "containerNumber": "رقم الحاوية",
  "attachPhoto": "إرفاق صورة",
  "submit": "إرسال الطلب",
  "save": "حفظ",
  "cancel": "إلغاء",
  
  // Messages
  "requestSent": "تم إرسال الطلب بنجاح",
  "requestCompleted": "تم إنجاز الطلب",
  "photoRequired": "الصورة مطلوبة",
  "locationRequired": "الموقع مطلوب",
  "containerNumberRequired": "رقم الحاوية مطلوب",
  
  // General
  "back": "رجوع",
  "next": "التالي",
  "confirm": "تأكيد",
  "edit": "تعديل",
  "delete": "حذف",
  "view": "عرض",
  "search": "بحث",
  "filter": "تصفية",
  "date": "التاريخ",
  "time": "الوقت",
  "status": "الحالة",
  "details": "التفاصيل"
};

export default common;